export default config => {
  const token = `Bearer ${sessionStorage.getItem('token')}` || '';
  const contrato = sessionStorage.getItem('contratoId') || '';
  const tenant = sessionStorage.getItem('tenant') || '';

  const configuration = {
    ...config,
    headers: {
      ...config.headers,
      Authorization: token,
      ContractIdentify: contrato,
      ServiceIdentify: tenant,
    },
  };

  return configuration;
};
